var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _ellipse, _path10, _path11, _path12, _path13, _path14, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwelve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #1f2f60;\n      }\n\n      .cls-2 {\n        opacity: .54;\n      }\n\n      .cls-3 {\n        fill: #ccc;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M755.75,86.76v331.98H56V94.71c0-29.92,17.79-47.71,39.76-47.71h620.23c21.97,0,39.76,17.79,39.76,39.76Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M755.75,418.74v493.01c0,21.97-17.79,39.76-39.76,39.76H95.76c-21.97,0-39.76-17.79-39.76-31.81v-500.96h699.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M155.4,311.39v-157.05c0-15.37,12.46-27.83,27.83-27.83h485.05c15.37,0,27.83,12.46,27.83,27.83v157.05c0,15.37-12.46,27.83-27.83,27.83H183.23c-15.37,0-27.83-12.46-27.83-27.83Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M222.99,339.23h-39.76c-15.37,0-27.83-12.46-27.83-27.83v-157.05c0-15.37,12.46-27.83,27.83-27.83h39.76c-15.37,0-27.83,12.46-27.83,27.83v157.05c0,15.37,12.46,27.83,27.83,27.83Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M694.12,526.09v159.03h-269.36v-186.87h241.53c15.37,0,27.83,12.46,27.83,27.83Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M424.76,498.26v186.87H155.4v-155.06c0-19.34,12.46-31.81,27.83-31.81h241.53Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M424.76,685.12v186.87h-241.53c-15.37,0-27.83-12.46-27.83-23.86v-163.01h269.36Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M694.12,685.12v159.03c0,15.37-12.46,27.83-27.83,27.83h-241.53v-186.87h269.36Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M666.29,483.35H183.23c-24.37,0-42.74,20.08-42.74,46.72v318.07c0,20.65,19.97,38.76,42.74,38.76h483.07c23.57,0,42.74-19.17,42.74-42.74v-318.07c0-23.57-19.17-42.74-42.74-42.74ZM679.22,526.09v144.12h-239.55v-157.05h226.62c7.12,0,12.92,5.8,12.92,12.92ZM170.31,530.07c0-10.11,5.19-16.9,12.92-16.9h226.62v157.05h-239.55v-140.15ZM170.31,848.13v-148.1h239.55v157.05h-226.62c-7.46,0-12.92-6.28-12.92-8.95ZM679.22,844.16c0,7.12-5.8,12.92-12.92,12.92h-226.62v-157.05h239.55v144.12Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.19,793.47h-107.35c-8.24,0-14.91-6.67-14.91-14.91s6.67-14.91,14.91-14.91h107.35c8.24,0,14.91,6.67,14.91,14.91s-6.67,14.91-14.91,14.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M344.25,576.78h-28.82v-28.82c0-8.24-6.67-14.91-14.91-14.91s-14.91,6.67-14.91,14.91v28.82h-28.82c-8.24,0-14.91,6.67-14.91,14.91s6.67,14.91,14.91,14.91h28.82v28.82c0,8.24,6.67,14.91,14.91,14.91s14.91-6.67,14.91-14.91v-28.82h28.82c8.24,0,14.91-6.67,14.91-14.91s-6.67-14.91-14.91-14.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M571.09,591.69l20.38-20.38c5.82-5.82,5.82-15.26,0-21.09-5.82-5.82-15.26-5.82-21.09,0l-20.38,20.38-20.38-20.38c-5.82-5.82-15.26-5.82-21.09,0-5.82,5.82-5.82,15.26,0,21.09l20.38,20.38-20.38,20.38c-5.82,5.82-5.82,15.26,0,21.09,2.91,2.91,6.73,4.37,10.54,4.37s7.63-1.46,10.54-4.37l20.38-20.38,20.38,20.38c2.91,2.91,6.73,4.37,10.54,4.37s7.63-1.46,10.54-4.37c5.82-5.82,5.82-15.26,0-21.09l-20.39-20.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M618.58,296.48h-27.83c-19.18,0-34.79-15.61-34.79-34.79v-57.65c0-19.18,15.61-34.79,34.79-34.79h27.83c19.18,0,34.79,15.61,34.79,34.79v57.65c0,19.18-15.61,34.79-34.79,34.79ZM590.75,199.08c-2.74,0-4.97,2.23-4.97,4.97v57.65c0,2.74,2.23,4.97,4.97,4.97h27.83c2.74,0,4.97-2.23,4.97-4.97v-57.65c0-2.74-2.23-4.97-4.97-4.97h-27.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M755.75,418.74v-44.73H125.58c-10.98,0-19.88-8.9-19.88-19.88V94.71c0-29.92,17.79-47.71,39.76-47.71h-49.7c-21.97,0-39.76,17.79-39.76,47.71v824.99c0,14.01,17.79,31.81,39.76,31.81h49.7c-21.97,0-39.76-17.79-39.76-31.81v-481.08c0-10.98,8.9-19.88,19.88-19.88h630.17Z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 839.24,
    cy: 613.56,
    rx: 204.76,
    ry: 45.72
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1044,895.35v93.93c0,29.82-91.66,45.72-204.76,45.72s-204.76-15.9-204.76-45.72v-93.93c0,29.82,91.66,45.72,204.76,45.72s204.76-15.9,204.76-45.72Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1044,801.42v93.93c0,29.82-91.66,45.72-204.76,45.72s-204.76-15.9-204.76-45.72v-93.93c0,29.82,91.66,45.72,204.76,45.72s204.76-15.9,204.76-45.72Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1044,707.49v93.93c0,29.82-91.66,45.72-204.76,45.72s-204.76-15.9-204.76-45.72v-93.93c0,29.82,91.66,45.72,204.76,45.72s204.76-15.9,204.76-45.72Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1044,613.56v93.93c0,29.82-91.66,45.72-204.76,45.72s-204.76-15.9-204.76-45.72v-93.93c0,29.82,91.66,45.72,204.76,45.72s204.76-15.9,204.76-45.72Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M516.5,827.55c-3.81,0-7.63-1.46-10.54-4.37-5.82-5.82-5.82-15.26,0-21.09l67.59-67.59c5.82-5.82,15.26-5.82,21.09,0,5.82,5.82,5.82,15.26,0,21.09l-67.59,67.59c-2.91,2.91-6.73,4.37-10.54,4.37h0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 521.18,
    cy: 740.79,
    r: 14.91
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 580.81,
    cy: 816.33,
    r: 14.91
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwelve);
export default __webpack_public_path__ + "static/media/twelve.31db915ff7231cf3de89a0f72852a905.svg";
export { ForwardRef as ReactComponent };